<app-loader-w-message *ngIf="isLoading" [loadingMessage]="''"></app-loader-w-message>

<div *ngIf="!isLoading">
    <app-profile-completion-card [completion]="completion"></app-profile-completion-card>
    <div *ngIf="completion == 100" class="row mt-5 justify-content-center align-items-center">
        <div class="col-md-3" style="max-width: 310px;">
            <a routerLink="/libro-compra-venta">
                <div class="card border-primary mb-3 grow" style="max-width: 18rem;">
                    <div class="card-header bg-primary border-primary">
                        <h5 style="color: white; font-weight: 900; font-size: 15px;text-align: center;">Mi
                            Evolución
                        </h5>
                    </div>
                    <div class="card-body text-primary" style="text-align: center;">
                        <img style="width: 77%;"
                            src="assets/images/landing-empresa/evolution.png">
                    </div>
                </div>
            </a>
            <p> </p>
        </div>
        <div *ngIf="selectedOrganization == '77378155-9'" class="col-md-3" style="max-width: 310px; cursor:pointer; height: 100%;">
            <a routerLink="/ofertas/browse">
                <div class="card border-primary mb-3 grow" style="max-width: 18rem;">
                    <div class="card-header bg-primary border-primary">
                        <h5 style="color: white; font-weight: 900; font-size: 15px;text-align: center;">Ofertas
                            Financieras</h5>
                    </div>
                    <div class="card-body text-secondary d-flex align-items-center justify-content-center">
                        <img style="width: 80%;"
                            src="assets/images/landing-empresa/ilustrcion-sce-empleo.png">
                    </div>
                    <div class="card-footer bg-transparent border-primary text-center text-primary">{{offerCount}} Ofertas</div>
                </div>
            </a>
        </div>
        <div *ngIf="selectedOrganization != '77378155-9'" class="col-md-3" style="max-width: 310px; height: 100%;" matTooltip="Este modulo aún no está disponible">
            <div class="card border-secondary mb-3" style="max-width: 18rem;">
                <div class="card-header bg-light border-secondary">
                    <h5 style="color: gray; font-weight: 900; font-size: 15px;text-align: center;">Ofertas Financieras
                    </h5>
                </div>
                <div class="card-body text-secondary d-flex align-items-center justify-content-center" style="text-align: center; height: 100%;">
                    <img class="disabled-module" style="width: 100%;"
                        src="assets/images/landing-empresa/ilustrcion-sce-empleo.png">
                </div>
            </div>
        </div>
        <div class="col-md-3" style="max-width: 310px;" matTooltip="Este modulo aún no está disponible">
            <div class="card border-secondary mb-3" style="max-width: 18rem;">
                <div class="card-header bg-light border-secondary">
                    <h5 style="color: gray; font-weight: 900; font-size: 15px;text-align: center;">Alertas
                    </h5>
                </div>
                <div class="card-body text-primary" style="text-align: center;">
                    <img class="disabled-module" style="width: 77%;"
                        src="assets/images/landing-empresa/web-alert-in-isometric-style-icon-editable-vector.jpg">
                </div>
            </div>
        </div>
        <div class="col-md-3" style="max-width: 310px;" matTooltip="Este modulo aún no está disponible">
            <div class="card border-secondary mb-3" style="max-width: 18rem;">
                <div class="card-header bg-light border-secondary">
                    <h5 style="color: gray; font-weight: 900; font-size: 15px;text-align: center;"> KPI's
                    </h5>
                </div>
                <div class="card-body text-primary" style="text-align: center;">
                    <img class="disabled-module" style="width: 85%;"
                        src="assets/images/landing-empresa/analisis-de-proyectos.png.webp">
                </div>
            </div>
        </div>
        <!-- <p (click)="onDropCredentials()" class="col-12 text-md-end text-center mt-5 btn btn-link"><i class="fa fa-times" aria-hidden="true"></i>Ya no quiero compartir mis credenciales</p> -->
        <p routerLink="/ofertas/select" class="col-12 text-md-end text-center mt-5 btn btn-link"><i class="fa fa-cog" aria-hidden="true"></i>
            Configurar ofertas</p>
    </div>
    
    <!-- PASAR A UN NGFOR -->
    <div *ngIf="completion < 100">
        <div class="completion-configuration-card card lift d-flex align-items-center justify-content-center">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1 d-flex align-items-center justify-content-center">
                        <i class="fa fa-check-circle-o completed-icon" aria-hidden="true"></i>
                    </div>
                    <div class="col-5 align-items-center justify-content-center">
                        <h3 class="text-muted">
                            Clave SII
                        </h3>
                    </div>
                    <div class="col-6 d-flex justify-content-end">
                        <!-- <button class="btn btn-primary">Completar</button> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="completion-configuration-card card lift d-flex align-items-center justify-content-center">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1 d-flex align-items-center justify-content-center">
                        <i class="fa fa-times missing-icon" aria-hidden="true"></i>
                    </div>
                    <div class="col-5 align-items-center justify-content-center">
                        <h3 class="text-muted">
                            Selección de ofertas
                        </h3>
                    </div>
                    <div class="col-6 d-flex justify-content-end">
                        <button class="btn btn-primary" routerLink="/ofertas/select">Completar</button>
                    </div>
                </div>
            </div>
        </div>
    
    
    
    
    
    </div>
</div>